;(function() {

	var instances = new WeakMap();

	function createInstance() {
		return {
			keypressed: false
		};
	}

	function getInstance(element) {
		if (!instances.has(element)) {
			instances.set(element, createInstance());
		}
		return instances.get(element);
	}

	document.addEventSelectorListener("keydown", "input[list]", function(event, target) {
		var instance = getInstance(target);
		instance.keypressed = !!event.key;
	});

	document.addEventSelectorListener("input", "input[list]", function(event, target) {
		var instance = getInstance(target);
		if (instance.keypressed) {
			// Standard keypress, nothing to do.
			return;
		}

		var value = target.value;

		// Try to find option.
		var options = document.querySelectorAll("#" + target.getAttribute("list") + " option");
		var option = null;
		for (var i = 0; i < options.length; ++i) {
			if (options[i].value == value) {
				option = options[i];
				break;
			}
		}


		if (!option) {
			// No option found.
			return;
		}

		var fields = option.getAttribute("data-fields");
		if (!fields) {
			return;
		}

		fields = JSON.parse(fields);
		for (var fieldName in fields) {
			var newValue = fields[fieldName];
			if (!newValue || !newValue.trim()) {
				continue;
			}

			var field = document.querySelector("input[name='" + fieldName + "'], textarea[name='" + fieldName + "']");

			if (field) {
				field.value = newValue;
			}
		}

	});

}());